/* app/js/src/components/mediaEditor/files-tab/thumbnail/thumbnail.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: relative;
  margin-right: 13px;
}
:host .thumbnail {
  width: 50px;
  height: 28px;
}
:host .thumbnail img {
  width: 100%;
  height: 100%;
}
:host icn-close-btn {
  position: absolute;
}
/*# sourceMappingURL=thumbnail.component.css.map */
